
import Checkbox from '@mui/material/Checkbox'
import React, { Fragment as F, useContext, useEffect, useState } from 'react'
import Modal from 'react-modal'
import { toast } from 'react-toastify'

import {
  useApiRouter,
  appRouter,
  C,
  logg,
} from '$shared'
import { AppCtx } from "$src/App"

import FiltersBox from './FiltersBox'

import {
  ListsModal,
  QueryModal,
  QueriesCtx,
  QueriesModal,
} from '$src/components/queries'

/*
 * ShareModal
**/
const ShareModal = (props) => {
  // logg(props, 'ShareModal')

  const apiRouter = useApiRouter()

  /* ctx */

  const {
    loading,    setLoading,
    selectedResource, setSelectedResource,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in ShareModal')

  const {
    shareModalOpen, setShareModalOpen,
  } = useContext(QueriesCtx)
  // logg(useContext(QueriesCtx), 'QueriesCtx in ShareModal')

  /* effects */

  useEffect(() => {
    if (shareModalOpen) {
      setLoading(true)
      fetch(apiRouter.resourceSharedPath(selectedResource)).then(r => r.json()).then((props) => {
        logg(props, 'shared?')
        const { is_shared, shared_with_str } = props

        setSelectedResource({ ...selectedResource, ...{ is_shared, shared_with_str } })
      }).catch((err) => {
        logg(err, 'err')
        toast('Could not retrieved sharing data.')
      }).finally(() => {
        setLoading(false)
      })
    }
  }, [ shareModalOpen ])

  /* methods */

  const handleSave = () => {
    setLoading(true)

    fetch(apiRouter.resourceSharePath(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        resource: selectedResource,
      }),
    }).then(r => r.json()).then((out) => {
      // logg(out, 'out')
      toast("Sharing successful.")
      if (out.unrecognized_emails && out.unrecognized_emails.length) {
        toast(`Some of the recipient emails were not recognized: ${out.unrecognized_emails.join(', ')}`)
      }
    }).catch((err) => {
      // logg(err, 'err')
      toast('Could not share the resource')
    }).finally(() => {
      setLoading(false)
      setShareModalOpen(false)
    })
  }


  return <F>
    <Modal
      ariaHideApp={false}
      className="ShareModal BaseModal DoL"
      isOpen={shareModalOpen}
      onRequestClose={ () => setShareModalOpen(false) }
      overlayClassName="ModalOverlay-z10"
    >
      <div className='header'>
        <h5 >Sharing</h5>
        <div className='close' onClick={() => setShareModalOpen(false)}>&times;</div>
      </div>
      <div className="container">

        <p>Please enter a comma (,) separated list of the
          email addresses of those with whom you wish to share, or check the box provided.</p>
          <textarea value={selectedResource.shared_with_str}
            onChange={(ev) => setSelectedResource({ ...selectedResource, shared_with_str: ev.target.value }) }
          />
        <div className='d-flex'>
          <Checkbox checked={selectedResource.is_shared}
            onChange={(ev) => setSelectedResource({...selectedResource, is_shared: !selectedResource.is_shared }) }
          />
          <label>Share with everyone in my company</label>
        </div>
      </div>
      <div className='actions'>
        <div className='left'></div>
        <div className='right'>
          <div className='Btn btn-primary' onClick={handleSave} >Save</div>
        </div>
      </div>
    </Modal>
  </F>
}
export default ShareModal
